import * as types from "../types";

export default function (state = {}, action) {
    const { type, payload } = action;

    switch (type) {
        case types.ADD_USER3:
            return {
                ...state,
                user3: payload
            };
        default:
            return state;
    }
}